import { render, staticRenderFns } from "./FormControlTemplatesTemplatesComponentId.vue?vue&type=template&id=cc6da5b2"
import script from "./FormControlTemplatesTemplatesComponentId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTemplatesTemplatesComponentId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports